export const getFullName = ({
  firstName,
  lastName
}: {
  firstName: string;
  lastName: string;
}): string => `${firstName} ${lastName}`;

export const getInitials = ({
  firstName,
  lastName
}: {
  firstName: string;
  lastName: string;
}): string => firstName.charAt(0) + lastName.charAt(0);
